export const dataUrlToFile = (dataUrl: string, fileName: string): File => {
  const [meta, base64Data] = dataUrl.split(",")
  const match = /data:(.*?);base64/.exec(meta || "")
  const mime = match?.[1] || "application/octet-stream"
  const binary = atob(base64Data || "")
  const len = binary.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return new File([bytes], fileName, { type: mime })
}
